module.exports = __webpack_public_path__ + "static/yaarvellyproductions-31e4a5b524c4d7a83eec0b1ff29dc4d8.jpg";